.bj{flex-shrink:0;}